import React, {
  useState, useReducer, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import { PhoneInput, Label } from '@americanexpress/dls-react';
import { validateDlsInput } from '../../Validations/Validations';

/**
 * returns DLS Phone Input component
 * @param {*} props
 */
const Phone = ({
  fieldValidation,
  cssProperties,
  fieldLabel,
  validations = [],
  fieldId,
  fieldRank,
  setValidationErrors,
  validationErrors,
  formSubmissionPayload,
}) => {
  const [data, setData] = useState(null);
  const [validationErrState, dispatchErrState] = useReducer((prevState, payload) => ({ ...prevState, ...payload }), { validationErr: '', isValid: true });

  useEffect(() => {
    if (formSubmissionPayload && formSubmissionPayload[fieldId]) {
      setData(formSubmissionPayload[fieldId]);
    } else {
      setData(null);
    }
  }, [fieldId]);

  const handleInput = (e) => {
    const inputVal = e ? e.target.value : '';
    if (validations.length > 0) {
      const invalidMsg = validateDlsInput(inputVal, validations);
      if (invalidMsg) {
        dispatchErrState({ validationErr: `${invalidMsg}`, isValid: false });
      } else {
        dispatchErrState({ validationErr: '', isValid: true });
      }
    }
    setData(inputVal);
  };

  const invalidHandler = (e) => {
    // e.target.setCustomValidity(' ');
    if (validations.length > 0) {
      e.preventDefault();
      handleInput(e);
    }
  };

  useEffect(() => {
    if (fieldRank) {
      // validationErr also can change multiple times, so need one isValid
      if (validationErrState.isValid && validationErrors[fieldRank]) {
        delete validationErrors[fieldRank];
        setValidationErrors({ ...validationErrors });
      } else if (!validationErrState.isValid) {
        setValidationErrors({ ...validationErrors, ...{ [fieldRank]: `${fieldId}` } });
      }
    }
  }, [validationErrState.isValid]);

  return (
    <div className={cssProperties.style}>
      <Label htmlFor={fieldId} className={fieldLabel.cssProperties.style}>
        {fieldLabel.label}
      </Label>
      <PhoneInput
        id={fieldId}
        value={data}
        locale={fieldValidation.locale}
        showFlag={fieldValidation.showFlag}
        showCallingCode={fieldValidation.showCallingCode}
        phoneFormat={fieldValidation.phoneFormat}
        callingCode={fieldValidation.callingCode}
        required={fieldValidation.required}
        onChange={handleInput}
        onInvalid={invalidHandler}
      />

      {
        validationErrState.validationErr
        && (
          <div id="alert-error" className={cssProperties.validationErrorStyle ? cssProperties.validationErrorStyle : 'alert dls-color-warning pad-1-t col-md-12'}>
            <span className="icon icon-sm dls-icon-warning-filled pad-1-r" />
            <span>{validationErrState.validationErr}</span>
          </div>
        )
      }
    </div>
  );
};

Phone.propTypes = {
  fieldValidation: PropTypes.objectOf(PropTypes.shape),
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  fieldLabel: PropTypes.objectOf(PropTypes.shape),
  fieldId: PropTypes.string,
  validations: PropTypes.arrayOf(PropTypes.shape),
  fieldRank: PropTypes.number,
  setValidationErrors: PropTypes.func,
  validationErrors: PropTypes.objectOf(PropTypes.shape),
  formSubmissionPayload: PropTypes.objectOf(PropTypes.shape),
};

export default Phone;
